// components/OcAppBar.tsx
import React from "react";
import { OcAppBarView } from "./app-bar-view";
import { useOcAppBar } from "./use-oc-appbar";

interface OcAppBarProps {
  onLogout: () => void;
}

export const OcAppBar: React.FC<OcAppBarProps> = ({ onLogout }) => {
  const {
    isMobile,
    employeeData,
    enabled,
    hasToRefresh,
    timeToRefresh,
    showRefreshDialog,
    onRefresh,
    currentVersion,
  } = useOcAppBar();

  return (
    <OcAppBarView
      isMobile={isMobile}
      employeeData={employeeData}
      enabled={enabled}
      hasToRefresh={hasToRefresh}
      timeToRefresh={timeToRefresh}
      showRefreshDialog={showRefreshDialog}
      onRefresh={onRefresh}
      currentVersion={currentVersion}
      onLogout={onLogout}
    />
  );
};

export default OcAppBar;
